"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteInvoicedAmountsResponseSchema = exports.QuoteInvoicedAmountsSchema = exports.InvoiceSearchQuerySchema = exports.QuoteInvoiceDetailsResponseSchema = exports.QuoteInvoiceDetailsSchema = exports.InvoiceDetailsResponseSchema = exports.InvoiceDetailsSchema = exports.InvoiceDetailsParams = exports.InvoicingProvidersResponseSchema = exports.UpdateInvoiceStatusRequestSchema = exports.InvoiceListResponseSchema = exports.InvoiceListSummarySchema = exports.InvoiceListSchema = exports.CreateInvoiceRequestSchema = exports.InvoiceCustomerListResponseSchema = exports.InvoiceCustomerQuotesSchema = exports.InvoiceOwingAmountResponseSchema = exports.InvoiceOwingAmountSchema = exports.InvoiceOwingAmountQuerySchema = exports.InvoiceTypes = exports.InvoiceStatus = void 0;
const zod_1 = require("zod");
const address_types_1 = require("./address.types");
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["DRAFT"] = "DRAFT_INVOICE";
    InvoiceStatus["PENDING"] = "PENDING";
    InvoiceStatus["SENT"] = "SENT";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["OVERDUE"] = "OVERDUE";
    InvoiceStatus["VOIDED"] = "VOIDED";
})(InvoiceStatus || (exports.InvoiceStatus = InvoiceStatus = {}));
var InvoiceTypes;
(function (InvoiceTypes) {
    InvoiceTypes["PARTIAL"] = "PARTIAL";
    InvoiceTypes["FINAL"] = "FINAL";
})(InvoiceTypes || (exports.InvoiceTypes = InvoiceTypes = {}));
exports.InvoiceOwingAmountQuerySchema = zod_1.z.object({
    customerId: zod_1.z.string().optional(),
    quoteId: zod_1.z.string().optional(),
});
exports.InvoiceOwingAmountSchema = zod_1.z.object({
    customers: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        firstName: zod_1.z.string(),
        lastName: zod_1.z.string(),
        email: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
        phoneNumber: zod_1.z.string(),
        customerShareAmount: zod_1.z.number(),
        customerPaidAmount: zod_1.z.number(),
        customerInvoicedAmount: zod_1.z.number(),
        customerBalanceAmount: zod_1.z.number(),
        invoices: zod_1.z.array(zod_1.z.object({
            id: zod_1.z.string(),
            number: zod_1.z.number(),
            amount: zod_1.z.number(),
            dueDate: zod_1.z.string().date(),
            createdAt: zod_1.z.string().date(),
            status: zod_1.z.nativeEnum(InvoiceStatus),
        })),
    })),
    quote: zod_1.z
        .object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        number: zod_1.z.number(),
        mainAddress: address_types_1.NewAddressSchema,
        totalAmount: zod_1.z.number(),
        variationTotalAmount: zod_1.z.number().optional(),
    })
        .optional(),
});
exports.InvoiceOwingAmountResponseSchema = zod_1.z.object({
    data: exports.InvoiceOwingAmountSchema,
});
const customerSummarySchema = {
    id: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    companyName: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    email: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    phoneNumber: zod_1.z.string(),
};
exports.InvoiceCustomerQuotesSchema = zod_1.z.object({
    customer: zod_1.z.object(customerSummarySchema),
    quotes: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        number: zod_1.z.number(),
        mainAddress: address_types_1.NewAddressSchema,
        quoteTotalAmount: zod_1.z.number(),
        customerShareAmount: zod_1.z.number(),
        customerPaidAmount: zod_1.z.number(),
        customerInvoicedAmount: zod_1.z.number(),
        customerBalanceAmount: zod_1.z.number(),
    })),
    customerOwingAmount: zod_1.z.number(),
});
exports.InvoiceCustomerListResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.InvoiceCustomerQuotesSchema),
});
exports.CreateInvoiceRequestSchema = zod_1.z.object({
    quoteId: zod_1.z.string().optional(),
    customerId: zod_1.z.string(),
    type: zod_1.z.nativeEnum(InvoiceTypes),
    // .min(1) at the boundary instead of a guard in each consumer: a zero-line invoice
    // persists fine (createMany([]) is a legal no-op) and then breaks everything downstream
    // — GET /invoices 500s permanently on `lineItems[0].name`, MYOB creates a remote contact
    // then POSTs an empty $0 invoice, QBO 400s on `Line: []`.
    // .int() because amount is persisted straight into InvoiceLineItem.price (an Int) with no
    // rounding: a fractional amount passed validation and then 500'd from inside Prisma, with
    // the absolute server path in the response body. Not .nonnegative() — a negative amount is
    // a credit line, which centsToDollars handles deliberately.
    lineItems: zod_1.z.array(zod_1.z.object({ name: zod_1.z.string(), amount: zod_1.z.number().int() })).min(1),
    dueDate: zod_1.z.string().date(),
});
exports.InvoiceListSchema = zod_1.z.object({
    id: zod_1.z.string(),
    number: zod_1.z.number(),
    status: zod_1.z.nativeEnum(InvoiceStatus),
    description: zod_1.z.string(),
    amount: zod_1.z.number(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
    dueDate: zod_1.z.string().date(),
    quoteId: zod_1.z.string().optional(),
    quoteNumber: zod_1.z.number().optional(),
    quoteAddress: address_types_1.NewAddressSchema.optional(),
    xeroId: zod_1.z.string().optional(),
    xeroNumber: zod_1.z.string().optional(),
    customer: zod_1.z.object(customerSummarySchema),
});
exports.InvoiceListSummarySchema = zod_1.z.object({
    [InvoiceStatus.PAID]: zod_1.z.number(),
    [InvoiceStatus.SENT]: zod_1.z.number(),
    [InvoiceStatus.OVERDUE]: zod_1.z.number(),
    [InvoiceStatus.DRAFT]: zod_1.z.number(),
});
exports.InvoiceListResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.InvoiceListSchema),
    meta: exports.InvoiceListSummarySchema,
});
exports.UpdateInvoiceStatusRequestSchema = zod_1.z.object({
    id: zod_1.z.string(),
    status: zod_1.z.nativeEnum(InvoiceStatus),
});
exports.InvoicingProvidersResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        xero: zod_1.z.boolean(),
        quickBooks: zod_1.z.boolean(),
        myob: zod_1.z.boolean(),
    }),
});
exports.InvoiceDetailsParams = zod_1.z.object({
    id: zod_1.z.string(),
});
exports.InvoiceDetailsSchema = zod_1.z.object({
    company: zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        registeredForTax: zod_1.z.boolean(),
        pricesIncludeTax: zod_1.z.boolean(),
        // The region's rate, resolved from Company.country. Carried here because the accounting
        // providers have to predict the tax their own side will add, and a hardcoded 0.1 silently
        // under-bills every NZ company by 5 points.
        gstRate: zod_1.z.number(),
    }),
    quote: zod_1.z
        .object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        number: zod_1.z.number(),
        notes: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
        mainAddress: address_types_1.NewAddressSchema,
    })
        .optional(),
    lineItems: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        tax: zod_1.z.number(),
        priceExTax: zod_1.z.number(),
        priceIncTax: zod_1.z.number(),
    })),
    customer: zod_1.z.object({
        id: zod_1.z.string(),
        email: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
        firstName: zod_1.z.string(),
        lastName: zod_1.z.string(),
        phoneNumber: zod_1.z.string(),
        companyName: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
        address: address_types_1.NewAddressSchema,
    }),
    id: zod_1.z.string(),
    number: zod_1.z.number(),
    createdAt: zod_1.z.string().date(),
    dueDate: zod_1.z.string().date(),
    status: zod_1.z.nativeEnum(InvoiceStatus),
    xeroId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    myobId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    quickBooksId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
});
exports.InvoiceDetailsResponseSchema = zod_1.z.object({
    data: exports.InvoiceDetailsSchema,
});
exports.QuoteInvoiceDetailsSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    number: zod_1.z.number(),
    mainAddress: address_types_1.NewAddressSchema,
    quoteTotalAmount: zod_1.z.number(),
    customers: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        firstName: zod_1.z.string(),
        lastName: zod_1.z.string(),
        email: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
        phoneNumber: zod_1.z.string(),
        customerBalanceAmount: zod_1.z.number(),
        customerInvoicedAmount: zod_1.z.number(),
        customerPaidAmount: zod_1.z.number(),
        customerShareAmount: zod_1.z.number(),
    })),
});
exports.QuoteInvoiceDetailsResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.QuoteInvoiceDetailsSchema),
});
exports.InvoiceSearchQuerySchema = zod_1.z.object({
    search: zod_1.z.string().optional(),
    customerId: zod_1.z.string().optional(),
    quoteId: zod_1.z.string().optional(),
});
exports.QuoteInvoicedAmountsSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    number: zod_1.z.number(),
    createdAt: zod_1.z.date(),
    mainAddress: address_types_1.NewAddressSchema,
    quoteTotalAmount: zod_1.z.number(),
    quoteInvoicedAmount: zod_1.z.number(),
    quotePaidAmount: zod_1.z.number(),
    quoteBalanceAmount: zod_1.z.number(),
});
exports.QuoteInvoicedAmountsResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.QuoteInvoicedAmountsSchema),
});
